import { useRef } from "react";
import axios from "axios";

export const useRequestOptions = () => {
    const requestInterceptor = useRef<number>();

    // if we have an existing interceptor, remove it before adding the new one
    if (requestInterceptor.current !== undefined) {
        axios.interceptors.request.eject(requestInterceptor.current);
    }

    // add authorization token to each request
    requestInterceptor.current = axios.interceptors.request.use(
        async function (config) {
            config.withCredentials = true;

            // Try to get aws waf token
            try {
                const token = await window.AwsWafIntegration.getToken();
                config.headers.set("x-aws-waf-token", token);
            } catch (error) {
                console.info("Unable get AWS WAF token");
            }

            // Add other headers that you need here
            return config;
        },
        function (error) {
            return Promise.reject(new Error(error));
        },
    );
};

export default useRequestOptions;